import React from "react"
import tw, { styled } from "twin.macro"

const MenuTitle = styled.h4`
  ${tw`flex flex-row justify-center m:justify-start items-center py-2 uppercase text-yellow font-display text-center whitespace-nowrap m:text-left`}
  font-size: 17px;
  letter-spacing: 0.4px;

  &.product {
    ${tw`text-sm leading-none mb-4`}
  }
`

export default MenuTitle
